import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=0553ff30&scoped=true"
import script from "./MemberCard.js?vue&type=script&lang=js&external"
export * from "./MemberCard.js?vue&type=script&lang=js&external"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=0553ff30&prod&scoped=true&lang=scss"
import style1 from "./MemberCard.vue?vue&type=style&index=1&id=0553ff30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553ff30",
  null
  
)

export default component.exports